// extracted by mini-css-extract-plugin
export default {"main":"Gracias_main__lioZ2","image":"Gracias_image__A40r8","title":"Gracias_title__+hQ0u","info":"Gracias_info__bUrEA"};